/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"

type UseDeliveryNo = {
  key?: any
  enabled?: boolean
  onSuccess?: (data: number) => void
}

type Response = {
  payload: {
    delivery_no: number
  }
}

export function useDeliveryNo({
  key = "",
  onSuccess,
  enabled = true
}: UseDeliveryNo) {
  const api = useApi()
  const [data, setData] = useState<number>(1)
  const [isLoading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    api
      .post('/invoice/get-delivery-no',)
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload

        onSuccess?.(data.delivery_no)
        setData(data.delivery_no)
      })
      .catch(() => setData(1))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    if (enabled) {
      fetchData()
    }

    return () => {
      setData(1)
      setLoading(false)
    }
  }, [enabled, key])

  return { data, isLoading, refetch }
}
